import React from "react";

export default function Marquee({ items, accent = false }) {
  const repeated = [...items, ...items, ...items, ...items];
  return (
    <div className={`w-full overflow-hidden border-y border-[color:var(--line)] ${accent ? "bg-[#0f0f10] text-[#faf9f5]" : "bg-[color:var(--bg)] text-[#0f0f10]"}`} data-testid="marquee">
      <div className="py-5">
        <div className="marquee-track">
          {repeated.map((item, i) => (
            <span key={`${item}-${i}`} className="label flex items-center gap-10 px-5 shrink-0" style={{ color: accent ? "#faf9f5" : undefined }}>
              <span>{item}</span>
              <span className={`w-1.5 h-1.5 ${accent ? "bg-[#faf9f5]/60" : "bg-[#0f0f10]/40"}`} />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
